import {
  getCookie,
  setCookie,
  removeCookie,
  safelySetCookie,
  channelDefaultValue
} from '../../commons/cookie';
import { moveToNextOrDefaultPage } from '../../commons/query';

export const GUEST = 'GUEST';
export const FACEBOOK = 'FACEBOOK';
export const GOOGLE = 'GOOGLE';
export const B2W = 'B2W';
export const B2W_RECV = 'B2W_RECV';
export const TELEMARKETER = 'TELEMARKETER';
export const B2W_WITH_TELEMARKETER = 'B2W_WITH_TELEMARKETER';

const setCustomerId = cookieValue => setCookie('customerId', cookieValue, 365);

const setCustomerLegacyId = cookieValue => setCookie('idLegacy', cookieValue, 365);

const setCustomerToken = cookieValue => setCookie('customerToken', cookieValue);

const setB2wUid = cookieValue => setCookie('b2wUid', cookieValue);

const setTelemarketerId = cookieValue => setCookie('telemarketerId', cookieValue);

const setTelemarketerToken = cookieValue => setCookie('telemarketerToken', cookieValue);

const setCustomerNickname = cookieValue => setCookie('nickname', cookieValue);

const setIsPrime = cookieValue => setCookie('cprime', cookieValue);

const setRegion = cookieValue => setCookie('region', cookieValue);

const setFinance = cookieValue => setCookie('cfinance', cookieValue);

const setPrivacyPolicy = cookieValue => setCookie('cPrivacyPolicy', cookieValue);

const setCustomerType = cookieValue => setCookie('customerType', cookieValue);

const setUserSegments = cookieValue => setCookie('b2wcrmts', cookieValue);

export const setUserEmail = cookieValue => setCookie('userEmail', cookieValue);

export const setChannelToTelemarketer = () => setCookie('channel', channelDefaultValue);

export const removeChannel = () => removeCookie('channel');

export const setFacebookAvatar = facebookUserID =>
  safelySetCookie(
    cookieValue => setCookie('facebookAvatar', cookieValue),
    `https://graph.facebook.com/${facebookUserID}/picture`
  );

export const removeFacebookAvatar = () => removeCookie('facebookAvatar');

export const isCustomerAuthenticated = () => getCookie('customerId') && getCookie('customerToken');

export const setEssentialCookies = ({ id, token, b2wUid }) => {
  if (!id || !token) {
    throw new Error('Id e token sao requeridos para logar');
  }
  setCustomerLegacyId(id);
  setCustomerId(id);
  setCustomerToken(token);
  setB2wUid(b2wUid);
};

export const setTelemarketerCookies = ({ id, token }) => {
  if (!id || !token) {
    throw new Error('Id e token sao requeridos para logar');
  }
  setTelemarketerId(id);
  setTelemarketerToken(token);
  setChannelToTelemarketer();
};

export const setAuxiliaryCookies = async ({
  nickname,
  isPrime,
  region,
  finance,
  customerType,
  userSegments
}) => {
  safelySetCookie(setCustomerNickname, nickname);
  safelySetCookie(setRegion, region);
  safelySetCookie(setIsPrime, isPrime);
  safelySetCookie(setFinance, finance);
  safelySetCookie(setCustomerType, customerType);
  safelySetCookie(setUserSegments, userSegments ? userSegments.segmentsIds.join(',') : '');
};

export const setPrivacyPolicyAgreement = version => safelySetCookie(setPrivacyPolicy, version);

export const setLoginCookies = customer => {
  setEssentialCookies(customer);
  setAuxiliaryCookies(customer);
};

export const setWarehouseCookies = (warehouse = {}) => {
  if (!warehouse.data || !warehouse.data.code) {
    return;
  }
  setCookie('warehouseId', warehouse.data.code);
  setCookie('salesChannel', warehouse.data.salesChannel);
  setCookie('persistentCep', warehouse.data.zipCode);
  setCookie('warehouseState', warehouse.data.state);
  setCookie('withTax', 'true');
};

const login = ({ constraints, ...customer }) => {
  setLoginCookies({ ...customer, privacyPolicy: 1 });
  moveToNextOrDefaultPage(constraints);
};

export const logout = () => {
  removeCookiesForLogout();
  moveToNextOrDefaultPage();
};

export const removeCookiesForLogout = () => {
  const cookiesToBeRemoved = [
    'customerId',
    'customerToken',
    'userEmail',
    'panelDomain',
    'warehouseId',
    'nickname',
    'salesChannel',
    'warehouseState',
    'withTax'
  ];

  cookiesToBeRemoved.forEach(removeCookie);
};

export default login;
